import { render } from "./ViewPropositionReponse.vue?vue&type=template&id=6fc4e6aa&scoped=true&ts=true"
import script from "./ViewPropositionReponse.vue?vue&type=script&lang=ts"
export * from "./ViewPropositionReponse.vue?vue&type=script&lang=ts"

import "./ViewPropositionReponse.vue?vue&type=style&index=0&id=6fc4e6aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc4e6aa"]])

export default __exports__